import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
//
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { useGlobalTheme } from '../../contexts/ThemeContext';
import '../../pages/OrgContact.scss'; // Inject global variables explicitly at Layout root
import './Dashboard.scss';

// ----------------------------------------------------------------------




// ----------------------------------------------------------------------

export default function Layout() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const ischatroom = pathname === '/chatroom';
  const { globalTheme } = useGlobalTheme();

  return (
    <div className={`dashboard-root global-theme-wrapper theme-${globalTheme}`}>
      <Navbar onOpenSidebar={() => setOpen(true)} />
      <Sidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
      <div className={`dashboard-main ${ischatroom ? 'main--chatroom' : ''}`}>
        <Outlet />
      </div>
    </div>
  );
}
